// @flow
import styled from '@emotion/styled';
import { spacing } from '@identity/spacing';
import { colors, DESKTOP } from '@identity/constants';
import { remCalc } from '@lib/styleMethods';
import { Content } from '@identity/wrappers';

export const FormContainer = styled(Content)`
  ${spacing({
    margin: { default: 'top-lg', desktop: 'top-xl' },
    padding: 'top-lg',
  })};
  padding-left: 7vw;
  padding-right: 7vw;
  display: flex;
  flex-direction: column;

  margin-right: auto;
  margin-left: auto;
  max-width: 600px;

  h1 {
    font-family: 'Playfair Display';
  }
`;

export const Arrow = styled.div`
  transition: transform 250ms ease-out;
  & svg {
    fill: ${colors.BLACK_006};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
  & svg {
    fill: ${colors.PRIMARY_004};
  }
  & h1 {
    color: ${colors.PRIMARY_004};
  }
  & ${Arrow} {
    color: ${colors.PRIMARY_004};
    transform: translateX(20px);
  }
  &:hover {
    & svg {
      fill: ${colors.PRIMARY_004};
    }
    & h1 {
      color: ${colors.PRIMARY_004};
    }
    & ${Arrow} {
      color: ${colors.PRIMARY_004};
      transform: translateX(20px);
    }
  }
`;

export const Form = styled.form`
  width: 100%;
  &:invalid ${ButtonContainer} {
    & svg {
      fill: ${colors.BLACK_006};
    }
    & h1 {
      color: ${colors.BLACK_006};
    }
    & ${Arrow} {
      color: ${colors.BLACK_006};
      transform: translateX(20px);
    }
  }
  p {
    color: #bf1650;
  }

  p::before {
    display: inline;
    content: '⚠ ';
  }

  input {
    display: block;
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 10px 15px;
    margin-bottom: 10px;
    font-size: 14px;
  }

  textarea {
    display: block;
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 10px 15px;
    margin-bottom: 10px;
    font-size: 14px;
  }

  label {
    line-height: 2;
    text-align: left;
    display: block;
    margin-bottom: 13px;
    margin-top: 20px;
    color: ${colors.BLACK_003};
    font-size: 14px;
    font-weight: 200;
  }

  input[type='submit'] {
    background: #ec5990;
    color: black;
    text-transform: uppercase;
    border: none;
    margin-top: 40px;
    padding: 20px;
    font-size: 16px;
    font-weight: 100;
    letter-spacing: 10px;
  }

  input[type='submit']:hover {
    background: #bf1650;
  }

  input[type='button']:active,
  input[type='submit']:active {
    transition: 0.3s all;
    transform: translateY(3px);
    opacity: 0.8;
  }

  input:disabled {
    opacity: 0.4;
  }

  input[type='button']:hover {
    transition: 0.3s all;
    color: pink;
  }

  input[type='button'],
  input[type='submit'] {
    -webkit-appearance: none;
  }

  .Dropdown-placeholder,
  .Dropdown-option {
    font-size: 14px;
  }
  ${spacing({ margin: 'top-md' })}
`;

export const Button = styled.button`
  background-color: ${colors.WHITE_ALPHA_100};
  border: none;
  cursor: pointer;
  outline: none;
  margin-top: 80px;

  h1 {
    font-family: 'Playfair Display';
    :hover {
      color: ${colors.PRIMARY_003};
    }
  }
`;
